import { useFieldArray, type UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/Button';
import { Select } from '@/components/Select';
import type { OpportunityFormValues } from '@/pages/Opportunities/formSchema';
import type { OpportunityCatalogs } from '@/pages/Opportunities/types';

export interface OpportunityClassificationsProps { form: UseFormReturn<OpportunityFormValues>; catalogs: OpportunityCatalogs; }
export const OpportunityClassifications = ({ form, catalogs }: OpportunityClassificationsProps) => {
    const { t } = useTranslation('global');
    const array = useFieldArray({ control: form.control, name: 'classifications' });
    return <section className="space-y-4"><h3 className="font-semibold">{t('opportunities.fields.classification')}</h3>
        {array.fields.map((row, index) => {
            const group = form.watch(`classifications.${index}.group_id`);
            const fields = [
                { key: 'group_id' as const, options: catalogs.classification_groups },
                { key: 'subgroup_id' as const, options: catalogs.classification_groups.find(item => String(item.id) === group)?.subgroups ?? [] },
                { key: 'category_id' as const, options: catalogs.classification_categories },
            ];
            return <div key={row.id} className="space-y-3 rounded-lg border border-slate-200 p-3 dark:border-white/15">
                {fields.map(field => <Select key={field.key} label={t(`opportunities.fields.${field.key}`)} required searchable value={form.watch(`classifications.${index}.${field.key}`)} options={field.options.map(option => ({ value: String(option.id), label: `${option.code} · ${option.name}` }))}
                    error={form.formState.errors.classifications?.[index]?.[field.key]?.message} onChange={(value: string) => {
                        form.setValue(`classifications.${index}.${field.key}`, String(value), { shouldDirty: true });
                        if(field.key === 'group_id'){
                            form.setValue(`classifications.${index}.subgroup_id`, '', { shouldDirty: true });
                        }
                    }} />)}
                <Button variant="ghost" icon="trash" onClick={() => array.remove(index)}>{t('opportunities.remove_classification')}</Button>
            </div>;
        })}
        <Button variant="outline" icon="plus" onClick={() => array.append({ group_id: '', subgroup_id: '', category_id: '' })}>{t('opportunities.add_classification')}</Button>
    </section>;
};
